import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { HomeworkLink } from '../../../../../models/homework-link';
import { HomeworkService } from '../../../../../services/homework.service';
import { AssetService } from '../../../../../services/asset.service';
import { CommunicationService } from '../../../../../services/communication.service';
import { ModalService } from '../../../../../services/modal.service';
import { ApplicationStateService } from '../../../../../services/application-state.service';
import { RouteService } from '../../../../../services/route.service';
import { environment } from '../../../../../../environments/environment';
import { RestService } from '../../../../../services/rest.service';
import { AssetPipe } from '../../../../../pipes/asset.pipe';
import { TechnicalFeature } from '@lemberger/lemberger-am';
import { CrudService } from '../../../../../services/crud.service';

@Component({
    selector: 'sidebar-test-generator-item',
    templateUrl: './test-generator-item.component.html',
    styleUrls: ['./test-generator-item.component.scss'],
    standalone: true,
    imports: [
        AssetPipe
    ]
})
export class TestGeneratorItemComponent implements OnInit {
    @Output() readonly editTest = new EventEmitter<HomeworkLink>();

    @Input() test: HomeworkLink;
    @Input() foreign?: boolean;

    private crudService = inject(CrudService);

    date: Date;

    opened = false;
    title;
    downloadLink: string;
    link: string;
    loading: boolean;

    constructor(public assetService: AssetService,
                public communicationService: CommunicationService,
                public applicationStateService: ApplicationStateService,
                public homeworkService: HomeworkService,
                public restService: RestService,
                public routeService: RouteService,
                private modalService: ModalService) {
    }

    ngOnInit(): void {
        this.title = this.getTitle();
        // @ts-ignore
        this.date = new Date(this.test.dueDate * 1000);
        this.downloadLink = this.homeworkService.getEvaluationLink(this.test);
        this.link = this.test.getLink();
    }

    /**
     * event handler to show link
     *
     * @param {HomeworkLink} homework
     */
    showLink(homework: HomeworkLink): void {
        this.homeworkService.openHomework();
        this.opened = true;
        homework.bypassCheck = true;
        this.modalService.openModal(this.test);
    }

    /**
     * is homework modal opened
     *
     * @returns {boolean}
     */
    isModalOpen(): boolean {
        if (!this.homeworkService.isHomeworkOpened()) {
            this.opened = false;
        }

        return this.opened;
    }

    toggleSelectedForDeletion(): void {
        this.test.selectedForDeletion = !this.test.selectedForDeletion;
    }

    /**
     * get title of homework
     *
     * @return {string}
     */
    getTitle(): string {
        return this.test.title || `${this.test.domain}/${this.test.link}`;
    }

    edit(): void {
        this.editTest.emit(this.test);
    }

    // /**
    //  * get route to pdf (OLD implementation, on HAM server)
    //  *
    //  * @return {string}
    //  */
    // getPdfDownload(): string {
    //   return `https://o-le.org/worksheet/${this.test.created}`;
    // }

    getPdfDownload() {
        const assignments = this.test.exercises.map(exercise => {
            if (typeof exercise === 'string') {
                return exercise;
            }

            return exercise.text;
        }).join(',');
        this.restService.post(
            this.routeService.getAbsoluteRoute(environment.endpointUrls.exportPdf, []),
            { assignments: assignments, title: this.test.title, type: 'test' },
            new Headers({
                'Content-Type': 'application/json'
            }),
            'blob' as 'json',
            true
        ).then((response: Blob) => {
            const blob = new Blob([response], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'export.pdf';
            a.click();
            window.URL.revokeObjectURL(url);
        }).catch(error => {
            console.error('Download error:', error);
        });

        this.crudService.logDirect(TechnicalFeature.TestPdfDownload);
    }

    protected deleteTest(test: HomeworkLink) {
        if (!test.id) {
            this.homeworkService.tests = this.homeworkService.tests.filter(elem => elem !== test);
        } else {
            this.homeworkService.removeHomework(test)
                .then(() => {
                    this.homeworkService.tests = this.homeworkService.tests.filter(elem => elem !== test);
                })
                .catch(() => {
                    return;
                })
        }
    }
}
